import axios from 'axios';

import {
  httpErrorHandler,
  httpSuccessHandler,
  httpSetRequestHeaders,
} from '@ncl/modules/shared/services/httpMiddleware';

class ResponsabilityTermService {
  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_BFF_SERVICE,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    this.instance.interceptors.response.use(httpSuccessHandler, (error) => {
      return httpErrorHandler(error, this.instance);
    });
    this.instance.interceptors.request.use(httpSetRequestHeaders);

    this.instance.defaults.raxConfig = {
      instance: this.instance,
    };
  }

  getTermDocument(description, version) {
    return `${process.env.REACT_APP_BFF_SERVICE}/terms/term-document/${description}/version/${version}`;
  }

  getYoutubeEmbedId(description, version) {
    return this.instance.get(`/terms/term-document/${description}/version/${version}`);
  }
}

const responsabilityTermService = new ResponsabilityTermService();

export default responsabilityTermService;
